var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EmptyView,{attrs:{"name":_setup.text.name,"description":_setup.text.description},scopedSlots:_vm._u([{key:"icon",fn:function(){return [(_setup.isCreatingConversationForCallUser)?_c(_setup.NcLoadingIcon):_c(_setup.NcIconSvgWrapper,{attrs:{"svg":_setup.IconTalk}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }